export default {
  path: '/',
  name: 'systemLog',
  hidden: false,
  meta: {
    title: '系统日志',
    level: 1,
    nav: 'log',
    icon: 'fa fa-tasks iconTitle',
    role: ['admin']
  },
  component: () => import('@/views/Application.vue'),
  children: [
    {
      path: '/systemLog',
      name: 'systemLog',
      hidden: false,
      meta: {
        title: '系统日志',
        level: 2,
        nav: 'systemLog',
        iconClass: 'icon-task',
        icon: 'fa fa-tasks iconTitle',
        role: ['admin']
      },
      component: () => import('@/views/system/SystemLog.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/system-error.js